<template>
    <div id="edit_quote_policy" v-if="quote_policy">
        <div class="ui segment">
            <div class="ui horizontal divider">
                <h3>
                    <i class="edit icon"></i>
                    編輯計價政策
                </h3>
            </div>
            <div class="ui form">
                <div class="ui grid" style="margin-top:0;margin-bottom:0">
                    <div class="eight wide field" data-column="name">
                        <label>名稱</label>
                        <input
                            type="text"
                            v-model="quote_policy.name">
                    </div>
                    <div class="eight wide field" data-column="note">
                        <label>備註</label>
                        <input
                            type="text"
                            v-model="quote_policy.note">
                    </div>
                    <div class="eight wide field" data-column="required_material_class_name">
                        <label>條件物料</label>
                        <input
                            type="text"
                            v-model="quote_policy.required_material_class_name">
                    </div>
                    <div class="eight wide field" data-column="required_condition">
                        <label>條件名稱</label>
                        <input
                            type="text"
                            v-model="quote_policy.required_condition">
                    </div>
                    <div class="eight wide field">
                        <div class="ui checkbox" v-checkbox>
                            <input type="checkbox" tabindex="0" class="hidden" v-model="quote_policy.required_condition_polarity">
                            <label>條件極性</label>
                        </div>
                    </div>
                    <div class="eight wide field">
                        <div class="ui checkbox" v-checkbox>
                            <input type="checkbox" tabindex="0" class="hidden" v-model="quote_policy.is_activated">
                            <label>是否啟用</label>
                        </div>
                    </div>
                </div>

                <div class="ui divider"></div>

                <div class="ui buttons">
                    <a href="#" @click.prevent="$router.go(-1)" class="ui button">
                        {{ $t('ui.general.back') }}
                    </a>
                    <div class="or"></div>
                    <a href="#" v-if="!is_loading" @click.prevent="update_quote_policy()" class="ui blue button">{{ $t('ui.general.update') }}</a>
                    <a href="#" v-else class="ui blue button">
                        {{ $t('ui.general.updating') }}...
                    </a>
                </div>
            </div>
        </div>
        <div class="ui segment">
            <div class="ui horizontal divider">
                <h3>
                    <i class="list icon"></i>
                    計價條件
                </h3>
            </div>
            <table class="ui table">
                <thead>
                    <tr>
                        <th>名稱</th>
                        <th>計價屬性</th>
                        <th>優先度</th>
                        <th>計價條件</th>
                        <th>價格公式</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="quote_condition in quote_policy.quote_conditions">
                        <td>{{ quote_condition.name }}</td>
                        <td>{{ quote_condition.quote_condition_type == 'conditional' ? '一般':'加收' }}</td>
                        <td>{{ quote_condition.priority || '-' }}</td>
                        <td>
                            <span v-if="quote_condition.condition_type == 'attribute'">
                                {{ $t('models.attributes.core_waybills.' + quote_condition.condition_attribute) }}
                            </span>
                            <span v-else>
                                {{ quote_condition.condition_value }}
                            </span>
                            ({{ quote_condition.condition_unit }})
                            &nbsp;
                            {{ translate_logical_operator(quote_condition.logical_operator) }}
                            &nbsp;
                            {{ quote_condition.result }}
                        </td>
                        <td>
                            <span v-if="quote_condition.price_type == 'attribute'">
                                {{ $t('models.attributes.core_waybills.' + quote_condition.price_attribute) }}
                            </span>
                            <span v-else>
                                {{ quote_condition.price_value }}
                            </span>
                            {{ quote_condition.price_operator }}
                            {{ quote_condition.price_operator_value }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="ui segment">
            <div class="ui horizontal divider">
                <h3>
                    <i class="list alternate icon"></i>
                    報價單
                    <router-link :to="{
                        name: 'new_provider_quotation',
                        params: {
                            quote_policy_identity: quote_policy.identity
                        }}">
                        <i class="add icon"></i>
                    </router-link>
                </h3>
            </div>
            <table class="ui table">
                <thead>
                    <tr>
                        <th>名稱</th>
                        <th>起</th>
                        <th>訖</th>
                        <th>檔案位址</th>
                        <th>動作</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="quotation in quote_policy.quotations">
                        <td>{{ quotation.title }}</td>
                        <td>{{ human_datetime(quotation.quoted_from) }}</td>
                        <td>{{ human_datetime(quotation.quoted_to) }}</td>
                        <td>
                            <a :href="quotation.file_url" v-if="quotation.file_url">下載檔案</a>
                            <span v-else>-</span>
                        </td>
                        <td>
                            <a href="#" @click.prevent="caculate()" class="ui orange button">
                                計算
                            </a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import moment from "moment"
import Validator from '@toolbox/validator/main.js'

export default {
    name: "ProviderEditQuotePolicy",
    mixins: [
        Validator
    ],
    props: {
    },
    data() {
        return {
            is_loading: false,
            quote_policy: {},
            third_party_api_data: ""
        }
    },
    watch: {

    },
    mounted() {
        this.fetch_quote_policy()
    },
    methods: {
        human_datetime(data, format="lll") {
            return moment(data).locale("zh-tw").format(format)
        },
        translate_logical_operator(logical_operator) {
            switch (logical_operator) {
                case 'between?':
                    return '介於'
                    break
                default:
                    return logical_operator
            }
        },
        fetch_quote_policy(context, payload) {
            var url = new RestUrl(this.$store.state.provider.routes.api_v1_provider_quote_policy).parse({
                quote_policy_identity: this.$route.params.quote_policy_identity,
            })

            return axios.get(url, { headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then(response => {
                    console.log(response)
                    this.quote_policy = response.data.quote_policy
                })
                .catch(error => {
                    return Promise.reject(error)
                })
        },
        update_quote_policy() {
            if (this.valid()) {
                this.is_loading = true

                var params = this.quote_policy
                var url = new RestUrl(this.$store.state.provider.routes.api_v1_provider_quote_policy_update).parse(
                    {
                        quote_policy_identity: this.quote_policy.identity
                    }
                )

                return axios.post(url, params, { headers: { Authorization: localStorage.getItem("authentication_token") }}).then(response => {
                    if (response.data.status == "success") {
                        // this.$noty.success("更新客戶合約成功")
                        this.$noty.success(
                            this.$t('ui.notifications.success.update__name', {
                                name: this.$t('models.quote_policys')
                            })
                        )
                        this.is_loading = false
                        this.$router.go(-1)
                    } else {
                        // this.$noty.error("更新客戶合約失敗")
                        this.$noty.error(
                            this.$t('ui.notifications.error.create__name', {
                                name: this.$t('models.quote_policys')
                            })
                        )
                        this.is_loading = false
                    }
                })
                .catch(error => {
                    // this.$noty.error("更新客戶合約失敗")
                    this.$noty.error(
                        this.$t('ui.notifications.error.update__name', {
                            name: this.$t('models.quote_policys'),
                        })
                    )
                    this.is_loading = false
                })
            }
        }
    },
    validator: {
        target: "quote_policy",
        localize_key: "quote_policys",
        input_alert: true,
        attributes: [
            {
                name: "name",
                required: true
            }
        ]
    },
    computed: {
        current_store() {
            return this.$store.state.provider.customers_module
        },
        current_customer() {
            return _.findLast(this.current_store.customers, customer => {
                return customer.identity == this.quote_policy.customer_identity
            })
        }
    },
    components: {
    }
}
</script>

<style lang="scss">
</style>
